import React, { useState, useMemo, useCallback } from 'react';

import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import { DateTime, Input, RadioGroup, Autocomplete } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelDesempenhoMotorista() {
  const [open, setOpen] = useState(true);
  const [produto, setProduto] = useState(true);
  const [motorista, setMotorista] = useState({});

  console.log(motorista);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsDriver = useMemo(
    () => [
      {
        id: 'nomemotorista',
        label: t('s.cadastro.motorista.nomemotorista'),
        filter: { type: 'text' },
      },
      {
        id: 'idmotorista',
        label: t('s.cadastro.motorista.idmotorista'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const onValidation = useCallback(async (values) => {
    console.log('VALUES', values);
    try {
      const schema = Yup.object().shape({
        idproduto: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
      });

      await schema.validate(values, {
        abortEarly: false,
      });
    } catch (error) {
      const form = {};

      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((err) => {
          form[err.path] = err.message.replace(`${err.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  function handleSerializeForm(params) {
    return {
      ...params,
      nomeproduto: produto?.nomeproduto,
      nomemotorista: motorista?.nomemotorista,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.reldesempenhomotorista')}
      relatorio="desempenhomotorista"
      serialize={(param) => handleSerializeForm(param)}
      validate={(values) => onValidation(values)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <PesquisaTabela
        name="idmotorista"
        label={t('s.menu.cadastro.motorista')}
        primary="idmotorista"
        secondary="nomemotorista"
        url="motoristas"
        header={cellsDriver}
        getValue={(value) => {
          setMotorista(value);
        }}
        onChange={(value) => setMotorista(value.target.value)}
      />

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        value={produto}
        getValue={(value) => {
          setProduto(value);
        }}
      />

      <RadioGroup
        name="analisereport"
        label={t('s.relatorio.geral.analise')}
        options={[
          {
            label: t('s.relatorio.geral.analiseanalitico'),
            value: 'Analitico',
          },
          {
            label: t('s.relatorio.geral.analisesintetico'),
            value: 'Sintetico',
          },
        ]}
        defaultValue="Analitico"
        serialize={(value) => value}
        row
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelDesempenhoMotorista;
